import React from 'react';
import Logo from '../../assets/Logo';
import { Container } from 'semantic-ui-react';
import { Props } from '../../types';

export default function Layout(props: Props) {
    return (
        <>
            <Container textAlign='center'>
                <Logo />
                {props.children}
            </Container>
        </>
    );
}
